import {
  Component,
  AfterViewInit,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';

import * as Prism from 'prismjs';
import { BoxPrenotazioneLaboratorioDTO } from '../../model/newModel';

@Component({
  selector: 'app-box-laboratorio',
  templateUrl: './box-laboratorio.component.html',
  styleUrls: ['./box-laboratorio.component.css'],
})
export class BoxLaboratorioComponent implements AfterViewInit {
  @Input() boxLaboratorio: BoxPrenotazioneLaboratorioDTO;
  @Output() prenotazione = new EventEmitter();
  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  prenota() {
    const obj = {
      idLaboratorio: this.boxLaboratorio.id,
      dataLaboratorio: this.boxLaboratorio.dayHours.date,
    };
    this.prenotazione.emit(obj);
  }
}
